import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import ContentEditable from '../ReactContenteditable';
import maxWidthMemo from '../maxWidthMemo';
import linkify from '../LinkHandlers';

var noop = function noop(event) {
  return event.preventDefault();
};

function Button(_ref) {
  var _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      href = _ref.href,
      target = _ref.target,
      className = _ref.className,
      onEnter = _ref.onEnter,
      onLeave = _ref.onLeave,
      activate = _ref.activate,
      style = _ref.style,
      edit = _ref.edit,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? {} : _ref$editable,
      children = _ref.children,
      _ref$innerClassName = _ref.innerClassName,
      innerClassName = _ref$innerClassName === void 0 ? '' : _ref$innerClassName,
      _ref$uiEvents = _ref.uiEvents,
      uiEvents = _ref$uiEvents === void 0 ? null : _ref$uiEvents;

  var _ref2 = style || {},
      maxWidth = _ref2.maxWidth,
      inlineStyles = _objectWithoutPropertiesLoose(_ref2, ["maxWidth"]);

  var maxWidthStyle = maxWidthMemo(maxWidth);

  if (process.env.ENV_RAW || !edit) {
    var _linkify = linkify({
      href: href,
      target: target
    }),
        Component = _linkify.Component,
        props = _linkify.props;

    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: inlineStyles
    }, /*#__PURE__*/React.createElement(Component, Object.assign({
      className: 'btn ' + innerClassName
    }, props, {
      dangerouslySetInnerHTML: {
        __html: content
      },
      style: maxWidthStyle
    })));
  }

  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className,
    style: inlineStyles
  }, uiEvents), /*#__PURE__*/React.createElement(ContentEditable, Object.assign({
    tagName: "a",
    className: 'btn ' + innerClassName,
    href: "#",
    html: content,
    onClick: noop,
    style: maxWidthStyle
  }, editable)), children);
}

Button.className = 'btn-box';
export { Button };